import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

import { ContactService } from '@features/contacts/services/contact.service';
import { TrustService } from '@features/contacts/services/trust.service';

import { Content, TrustDetailsComponent } from '../trust-details.component';

@Component({
  selector: 'spark-contacts-trust-edit',
  templateUrl: '../trust-details.component.html'
})
export class TrustEditComponent
  extends TrustDetailsComponent
  implements OnInit
{
  readonly isNewEntity = false;

  get title(): string {
    return 'Edit Trust';
  }

  get saveLabel(): string {
    return 'Save';
  }

  constructor(
    trustService: TrustService,
    fb: FormBuilder,
    private readonly contactService: ContactService
  ) {
    super(trustService, fb);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  content(): Observable<Content> {
    return this.trustService.getTrustForDisplay(this.trustId).pipe(
      switchMap((trust) => {
        let contactIds: string[] = [
          ...(trust.trustees || []),
          ...(trust.beneficiaries || []).map((s) => s.id)
        ];

        return this.contactService.getSpecificContacts(contactIds).pipe(
          map((contacts) => ({
            trust,
            contacts
          }))
        );
      })
    );
  }
}
